import {
  pageheaderDetailFragment,
  pageheaderFragment
} from "@saleor/fragments/pageheader";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  PageheaderDetails,
  PageheaderDetailsVariables
} from "./types/PageheaderDetails";
import {
  PageheaderList,
  PageheaderListVariables
} from "./types/PageheaderList";

const pageheaderList = gql`
  ${pageheaderFragment}
  ${pageInfoFragment}
  query PageheaderList(
    $filter: PageHeaderFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: PageHeaderSortingInput
  ) {
      pageHeaders(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
      sortBy: $sort
    ) {
      totalCount
      edges {
        node {
          ...PageheaderFragment
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;

export const usePageheaderListQuery = makeQuery<
  PageheaderList,
  PageheaderListVariables
>(pageheaderList);

const pageheaderDetails = gql`
  ${pageheaderDetailFragment}
  query PageheaderDetails(
    $id: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    pageHeader(id: $id) {
      ...PageheaderDetailFragment
    }
  }
`;

export const usePageheaderDetailsQuery = makeQuery<
PageheaderDetails,
  PageheaderDetailsVariables
>(pageheaderDetails);
